import { render } from "./ModalCampaignReward.vue?vue&type=template&id=68a062b6&scoped=true"
import script from "./ModalCampaignReward.vue?vue&type=script&lang=js"
export * from "./ModalCampaignReward.vue?vue&type=script&lang=js"

import "./ModalCampaignReward.vue?vue&type=style&index=0&id=68a062b6&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a062b6"]])

export default __exports__